import { api } from "roboflex-thalamus-request-handler";
import { downloadFromArrayBuffer } from "@/utils/download";

/**
 * Lista tarefas do usuário conforme filtros (Gestão de Tarefas).
 * @param {Object} payload - { dtInicio, dtFim, idUser, statusProjetoPa, statusTarefa }
 * @returns {Promise<Array>} Lista de tarefas
 */
export async function listarTarefasUsuario(payload) {
  const { data } = await api.post("gestao/tarefasUsuario", payload);
  return data;
}

/**
 * Gera e faz download do relatório de tarefas em Excel.
 * @param {Object} payload - { dtInicio, dtFim, idUser, statusProjetoPa, statusTarefa }
 */
export async function baixarRelatorioTarefasExcel(payload) {
  const response = await api.post(
    "gestao/tarefasUsuario",
    { ...payload, gerar: "xlsx" },
    { responseType: "arraybuffer" }
  );
  downloadFromArrayBuffer(response.data, "Relatório_Tarefas.xlsx");
}

/**
 * Lista todos os usuários (para perfil auditor).
 * @returns {Promise<Array>} Lista { id, name }[]
 */
export async function listarUsuarios() {
  const { data } = await api.get("usuario");
  return data;
}

/**
 * Lista subordinados do usuário por setor/responsável.
 * @param {number} usuarioId
 * @returns {Promise<Array>} Lista de subordinados { usuario_id, nome }[]
 */
export async function listarSubordinadosPorResponsavel(usuarioId) {
  const { data } = await api.post("setor/responsavel/usuario", {
    usuario_id: usuarioId,
  });
  return data;
}

/**
 * Atualiza uma tarefa de sprint (projeto).
 * @param {number} tarefaId
 * @param {Object} payload - { usuario_id, [campo]: valor }
 */
export async function atualizarSprintTarefa(tarefaId, payload) {
  const { data } = await api.put(`sprintTarefa/atualizar/${tarefaId}`, payload);
  return data;
}

/**
 * Atualiza uma tarefa de plano de ação (PAP).
 * @param {number} tarefaId
 * @param {Object} payload - { usuario_id, [campo]: valor }
 */
export async function atualizarPlanoAcaoTarefa(tarefaId, payload) {
  await api.put(`planoAcaoTarefa/atualizar/${tarefaId}`, payload);
}

/**
 * Atualiza uma tarefa de protocolo.
 * @param {number} tarefaId
 * @param {Object} payload - { usuario_id, [campo]: valor }
 */
export async function atualizarProtocoloTarefa(tarefaId, payload) {
  await api.put(`protocolo/tarefa/atualizar/${tarefaId}`, payload);
}

/**
 * Atualiza uma tarefa de reunião Google.
 * @param {number} reuniaoId - ID da reunião (google_reunioes.id)
 * @param {number} tarefaId - ID da tarefa (google_tarefas_reuniao.id)
 * @param {Object} payload - { status?, dt_inicio?, dt_fim?, descricao?, responsavel_id?, obs? } (status: pendente|em_andamento|concluida|cancelada)
 */
export async function atualizarTarefaReuniaoGoogle(reuniaoId, tarefaId, payload) {
  await api.patch(`google/calendar/reunioes/${reuniaoId}/tarefas/${tarefaId}`, payload);
}

/**
 * Adiciona anexo a uma tarefa de plano de ação (PAP).
 * @param {FormData} formData - deve conter planoAcaoTarefa_id e anexos[]
 * @returns {Promise<Object>} - { anexos_salvos: [{ path, nome, id }] }
 */
export async function adicionarAnexoPlanoAcaoTarefa(formData) {
  const { data } = await api.post("planoAcaoTarefa/anexo/adicionar", formData);
  return data;
}

/**
 * Cadastra nova tarefa em um plano de ação (PAP).
 * @param {Object} payload - { planoAcao_id, codigo, descricao }
 * @returns {Promise<Object>}
 */
export async function cadastrarTarefaPlanoAcao(payload) {
  const { data } = await api.post("planoAcaoTarefa/cadastrar", payload);
  return data;
}

/**
 * Exclui (marca como excluída) uma tarefa de plano de ação.
 * @param {number} idBacklog
 * @param {number} usuarioId
 */
export async function excluirTarefaPlanoAcao(idBacklog, usuarioId) {
  await api.put(`planoAcaoTarefa/excluir/${idBacklog}`, { usuario_id: usuarioId });
}
